



















































import Reflect from "reflect-metadata";
import { Component, Vue, Watch } from "vue-property-decorator";
import { User } from "@/models/User";

import session from "@/services/SessionService";
import messageService from "@/services/MessageService";
import userService, {
  UserPayload,
  PermissionsPayload,
} from "@/services/UserService";

import UserInfo from "@/components/UserInfo.vue";
import UserPermission from "@/components/UserPermission.vue";
import UserActions from "@/components/UserActions.vue";

type PermissionChangeEventPayload = {
  selectedBudgets: PermissionsPayload[];
  selectedProjects: PermissionsPayload[];
  selectedPlants: PermissionsPayload[];
};

@Component({
  components: {
    UserInfo,
    UserPermission,
    UserActions,
  },
})
export default class UserEdit extends Vue {
  static SAVE_SUCCESSFUL = 1;
  static SAVE_FAILED_EMAIL = 2;
  static SAVE_FAILED_SERVER = 3;
  static FETCH_FAILED = 4;

  loading: boolean = false;
  sessionUser: User | null;

  /**
   * Component data
   */
  payload: UserPayload = {
    user: {},
    permissions: [],
    security: {},
  };
  valid: boolean = false;

  /**
   * Class constructor.
   */
  constructor() {
    super();
    this.sessionUser = session.getUser();
  }

  /**
   * Saves the new user
   */
  updateUser() {
    this.loading = true;
    userService
      .save(this.payload)
      .then((response) => {
        messageService.addMessage({
          id: UserEdit.SAVE_SUCCESSFUL,
          type: "success",
          text: "El usuario se ha modificado exitosamente.",
          overrides: true,
        });
        if (this.sessionUser && this.payload.user.id == this.sessionUser.id) {
          session.update();
        }
        this.$router.back();
      })
      .catch((error) => {
        messageService.addMessage({
          id: UserEdit.SAVE_FAILED_SERVER,
          type: "error",
          text: "El usuario no se pudo modificar correctamente. Intente mas tarde.",
        });
        this.loading = false;
      });
  }
  /**
   * Executes when component is mounted. Sets event listeners and
   * gets the user from the API.
   */
  mounted() {
    this.$root.$on(
      "change:permissions",
      (payload: PermissionChangeEventPayload) => {
        this.payload.permissions = payload.selectedProjects.concat(
          payload.selectedBudgets.concat(payload.selectedPlants)
        );
      }
    );
    this.$root.$on("change:user", (payload: Partial<User>) => {
      this.payload.user = Object.assign(this.payload.user, payload);
    });

    userService
      .find(Number(this.$route.params.id))
      .then((response) => {
        this.payload.user = response.data
          ? (response.data as User)
          : this.payload.user;
        this.payload.permissions = response.data
          ? (response.data as User).permissions.map((item) => {
              return {
                plant_id: item.plant.id,
                budget_id: item.budget.id,
                project_id: item.project.id,
              };
            })
          : [];
        this.payload.user.permissions = undefined;
      })
      .catch((err) => {
        messageService.addMessage({
          id: UserEdit.FETCH_FAILED,
          type: "error",
          text: "Ocurrió un problema al intentar obtener el usuario. Intente más tarde.",
          overrides: true,
        });
      });
  }
}
